import { differenceInDays, format, isYesterday, parse } from "date-fns";
import { vi } from "date-fns/locale";

export const getTodayDate = (): string => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
};
export const getAgoMonth = (): string => {
  const today = new Date();
  today.setMonth(today.getMonth() - 1);
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
};
export const getTodayDateYearMonthTime = (): string => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Tháng bắt đầu từ 0
  const year = today.getFullYear();
  const hour = String(today.getHours()).padStart(2, "0");
  const minutes = String(today.getMinutes()).padStart(2, "0");
  const seconds = String(today.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year} ${hour}:${minutes}:${seconds}`;
};

export const getTodayYearMonthDay = (): string => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Tháng bắt đầu từ 0
  const year = today.getFullYear();
  return `${year}-${month}-${day}`; // Trả về định dạng YYYY-MM-DD
};

export const getCurrentTime = (): string => {
  const today = new Date();
  const hour = today.getHours().toString().padStart(2, "0");
  const minutes = today.getMinutes().toString().padStart(2, "0");
  return `${hour}:${minutes}`;
};
export const getDateOneMonthAgo = (): string => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const getCurrentDayTime = (): string => {
  const today = new Date();
  const day = today.getDate().toString().padStart(2, "0");
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  const year = today.getFullYear();
  const hour = today.getHours().toString().padStart(2, "0");
  const minutes = today.getMinutes().toString().padStart(2, "0");
  return `${day}/${month}/${year} ${hour}:${minutes}`;
};

export function isToday(dateString: string): boolean {
  const today = new Date();

  // Lấy ngày, tháng, năm của ngày hôm nay và định dạng lại theo kiểu MM/DD/YYYY
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = today.getFullYear();

  // Tạo chuỗi ngày hôm nay
  const todayFormatted = `${day}/${month}/${year}`;

  return dateString === todayFormatted;
}

export function isStartDateAfterEndDate(
  start_date: string, // Ví dụ: '14/01/2025 12:30'
  end_date: string // Ví dụ: '13/01/2025 15:45'
): boolean {
  // Tách ngày, tháng, năm và giờ, phút từ chuỗi truyền vào
  const [startDatePart, startTimePart] = start_date.split(" ");
  const [endDatePart, endTimePart] = end_date.split(" ");

  const [startDay, startMonth, startYear] = startDatePart.split("/").map(Number);
  const [endDay, endMonth, endYear] = endDatePart.split("/").map(Number);

  const [startHour, startMinute] = startTimePart.split(":").map(Number);
  const [endHour, endMinute] = endTimePart.split(":").map(Number);

  // Tạo đối tượng Date với thứ tự năm, tháng (0-11), ngày, giờ, phút
  const startDate = new Date(startYear, startMonth - 1, startDay, startHour, startMinute);
  const endDate = new Date(endYear, endMonth - 1, endDay, endHour, endMinute);

  return startDate > endDate;
}

export function isSameDate(start_date: string, end_date: string): boolean {
  // Tách phần ngày từ chuỗi truyền vào (bỏ qua phần giờ nếu có)
  const [startDatePart] = start_date.split(" ");
  const [endDatePart] = end_date.split(" ");

  // Tách ngày, tháng, năm từ chuỗi ngày
  const [startDay, startMonth, startYear] = startDatePart.split("/").map(Number);
  const [endDay, endMonth, endYear] = endDatePart.split("/").map(Number);

  // So sánh ngày, tháng, năm
  return startDay === endDay && startMonth === endMonth && startYear === endYear;
}

/**
 * Converts a date string from one format to another.
 * @param {string} dateString - The date string to be converted.
 * @param {string} currentFormat - The current format of the date string (e.g., 'dd/MM/yyyy').
 * @param {string} desiredFormat - The desired format to convert to (e.g., 'yyyy/MM/dd').
 * @returns {string} - The converted date string in the desired format.
 */
export const convertDateFormat = (dateString: string, currentFormat: string, desiredFormat: string) => {
  try {
    // Parse the date using the current format
    const parsedDate = parse(dateString, currentFormat, new Date());
    // Format it to the desired format
    return format(parsedDate, desiredFormat);
  } catch (error) {
    console.error("Error converting date:", error);
    return getTodayDate(); // Return null or an error message if conversion fails
  }
};
export function timeAgoChatMessage(dateString: string, isTimeLine: boolean = false): string {
  // Parse the input date string directly
  const dateFromInput = parse(dateString, "dd/MM/yyyy HH:mm:ss", new Date());
  const now = new Date();
  const dayDiff = differenceInDays(now, dateFromInput);

  try {
    if (isTimeLine) {
      if (dayDiff > 1) {
        return format(dateFromInput, "dd/MM/yyyy HH:mm:ss", { locale: vi });
      } else if (isYesterday(dateFromInput)) {
        return format(dateFromInput, "HH:mm", { locale: vi }) + " Hôm qua";
      } else {
        return format(dateFromInput, "HH:mm", { locale: vi }) + " Hôm nay";
      }
    } else {
      return format(dateFromInput, "HH:mm", { locale: vi });
    }
  } catch (error) {
    return "Invalid Date";
  }
}
